import { OAuthError, postData } from "../backend";
import { useModal } from "../contexts";
import { BLOCK_ICON_MAP, BLOCK_NAME_MAP } from "../utils";
import OAuthModalMicrosoft from "./OAuthModalMicrosoft";
import ErrorModal from "./ErrorModal";
import ESignatureLabel from "./ESginatureLabel";
import MicrosoftFileBrowser from "./MicrosoftFileBrowser";

interface Props {
  blockType: string;
  title: string;
  subtitle: string;
  onSelection: (blockType: string, fileId: string, driveId?: string) => void;
  allowedFileTypes: string;
  isComingSoon?: boolean;
  isSignable?: boolean;
}

function WorkflowSelectMicrosoftButton(props: Props) {
  const { openModal } = useModal();

  async function handleOpenPicker() {
    try {
      await postData("/microsoft/access-token/");

      openModal(
        <MicrosoftFileBrowser
          onSelect={(fileId: string, driveId?: string) => props.onSelection(props.blockType, fileId, driveId)}
          allowedFileTypes={props.allowedFileTypes}
        />
      );

    } catch (error) {
      if (error instanceof OAuthError)
        openModal(<OAuthModalMicrosoft oauthUrl={error.oauthUrl} onClose={handleOpenPicker} />);
      else
        openModal(<ErrorModal details={error} />);
    }
  }

  return (
    <button className={`relative flex flex-shrink-0 items-center border-2 border-gray-200 rounded px-8 py-4 ${props.isComingSoon ? "bg-gray-50 cursor-not-allowed" : "bg-white cursor-pointer hover:border-blue"} group`} onClick={() => handleOpenPicker()} disabled={props.isComingSoon}>
      <img className="w-12 h-12" src={BLOCK_ICON_MAP[props.blockType]} alt={BLOCK_NAME_MAP[props.blockType]} />
      <div className="flex flex-col items-start ml-4">
        <div className="font-gilroy font-semibold text-lg text-gray-600">
          {props.title}
        </div>
        <div className="font-gilroy font-semibold text-sm text-gray-400">
          {props.subtitle}
        </div>
      </div>
      {props.isComingSoon &&
        <div className="absolute -top-1 -right-2 bg-white shadow rounded border text-xs font-semibold px-2 py-1">
          <span className="text-gray-500">Coming Soon</span>
        </div>
      }
      {props.isSignable &&
        <ESignatureLabel />
      }
    </button>
  );
}

export default WorkflowSelectMicrosoftButton;
